import { RootState } from '@/store/store';
import {
    createEntityAdapter,
    createSelector,
    createSlice,
} from '@reduxjs/toolkit';
export type GoodRoad = {
    HostId: number;
    isGoodRoad: boolean;
    isRest: boolean;
};
export const GOOD_ROAD_KEY = 'app::goodRoad';
export const goodRoadsAdapter = createEntityAdapter<GoodRoad, number>({
    selectId: goodRoad => goodRoad.HostId,
    sortComparer: (a, b) => a.HostId - b.HostId,
});
const initialGoodRoadsState = goodRoadsAdapter.getInitialState();
const goodRoadsSlice = createSlice({
    name: GOOD_ROAD_KEY,
    initialState: initialGoodRoadsState,
    reducers: {
        updateAll: goodRoadsAdapter.upsertMany,
        update: goodRoadsAdapter.upsertOne,
    },
});
export const goodRoadsSliceReducer = goodRoadsSlice.reducer;
export const goodRoadsSliceActions = goodRoadsSlice.actions;
// selector
export const getGoodRoadsSelectors = goodRoadsAdapter.getSelectors<RootState>(
    state => state[GOOD_ROAD_KEY]
);
export const getIsGoodRoad = getGoodRoadsSelectors.selectById;
export const getIsGoodRoadIds = createSelector(
    [getGoodRoadsSelectors.selectAll],
    goodRoads =>
        goodRoads
            .filter(goodRoad => goodRoad.isGoodRoad && !goodRoad.isRest)
            .map(goodRoad => goodRoad.HostId)
);
